import {Trans} from '@lingui/macro';
import React from 'react';

import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {VirtualTableColumnCellsEnum} from '../../../../components/common/table/helpers/tableHelpers';
import {TableColumn} from '../../../../components/common/table/tableColumn';

/*
 * Constants.
 */

export const developersServersTableOriginColumnId = 'developers-servers-table-name';
export const developersServersTableAuthStrategyColumnId = 'developers-servers-table-auth-strategy';
export const developersServersTableDateCreatedColumnId = 'developers-servers-table-date-created';

export enum DevelopersServersTableColumnsEnum {
  ORIGIN = 'origin',
  AUTH_STRATEGY = 'auth_strategy',
  CREATED_DATE = 'created_date',
}

export const developersServersTableColumns: ReadonlyArray<TableColumn<DevelopersServersTableColumnsEnum>> = [
  {
    id: developersServersTableOriginColumnId,
    title: <Trans id="developers-servers-table-column-name">Origin</Trans>,
    type: DevelopersServersTableColumnsEnum.ORIGIN,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      sticky: {
        isSticky: true,
        stickyOffset: 0,
      },
      cellWidth: {
        shouldFillRemainingWidth: true,
        minWidth: 350,
        maxWidth: 350,
      },
      loading: {
        avatarSize: VisualSizesEnum.LARGE,
      },
    },
  },
  {
    id: developersServersTableAuthStrategyColumnId,
    title: <Trans id="developers-servers-table-column-auth-strategy">Authentication Strategy</Trans>,
    type: DevelopersServersTableColumnsEnum.AUTH_STRATEGY,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        minWidth: 200,
        maxWidth: 200,
      },
    },
  },
  {
    id: developersServersTableDateCreatedColumnId,
    title: <Trans id="developers-servers-table-column-created-date">Date created</Trans>,
    type: DevelopersServersTableColumnsEnum.CREATED_DATE,
    cellType: VirtualTableColumnCellsEnum.DATE,
    settings: {
      cellWidth: {
        minWidth: 160,
        maxWidth: 160,
      },
    },
  },
];
